module.exports = __webpack_public_path__ + "static/media/wallkingart.3c262049.png";